const mutations = {
  set(state, { type, value }) {
    state[type] = value;
  },
};

const actions = {
  setToken({ commit }, token) {
    commit('set', { type: 'token', value: token });
  },
  logout({ commit }) {
    commit('set', { type: 'token', value: null });
    localStorage.clear();
  },
};

const getters = {
  token: state => state.token,
  isAuthenticated: state => !!state.token,
};

const state = {
  token: null,
};

export default {
  namespaced: true,
  actions,
  getters,
  state,
  mutations,
};
